<template>
  <div>
    <transition name="slide">
      <div v-if="transition" class="wim-overlay"></div>
    </transition>
    <transition name="show">
      <div v-if="menuLateral && showMenu" class="wim-menu-lateral">
        <div
          v-for="(section, index) in content"
          :key="section.title"
          :class="['wim-menu-section', index === sectionIndex ? 'active' : '']"
          @click="goTo(index)"
        >
          <div class="wim-menu-section-white">
            <div class="wim-menu-progress" :style="`height: ${index < sectionIndex ? 0 : index === sectionIndex ? offset * 100 : 0}%`"></div>
          </div>
          <div class="wim-menu-section-text">
            <div class="wim-menu-section-name">{{section.title}}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import VueScrollTo from "vue-scrollto";

export default {
  props: ["content", "menuLateral", "sectionIndex", "offset"],
  data() {
    return {
      showMenu: true,
      transition: false
    };
  },
  methods: {
    goTo(index) {
      this.transition = true;

      setTimeout(() => {
        VueScrollTo.scrollTo(`#wim-section-${index}`, 1);
      }, 300);

      setTimeout(() => {
        this.transition = false;
      }, 600);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";
.wim-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99999;
  background: $red;

  &.slide-enter {
    left: -100%;
  }
  &.slide-enter-to {
    left: 0%;
    transition: left 0.3s cubic-bezier(0.8, 0.01, 0.84, 1);
  }
  &.slide-leave {
    left: 0%;
  }
  &.slide-leave-to {
    left: 100%;
    transition: left 0.3s cubic-bezier(0.12, 0.11, 0.25, 1);
  }
}
.wim-menu-lateral {
  position: fixed;
  top: 10vh;
  left: 30px;
  height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 4;
  &.show-enter {
    left: -100px;
    transition: left 1s ease;
  }
  &.show-enter-to {
    left: 25px;
    transition: left 1s ease;
  }
  &.show-leave {
    left: 25px;
    transition: left 1s ease;
  }
  &.show-leave-to {
    left: -100px;
    transition: left 1s ease;
  }
  .wim-menu-section {
    height: calc(80vh / 7);
    max-height: 90px;
    min-height: 76px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    margin-bottom: 12px;
    &:last-of-type {
      margin-bottom: 0;
    }
    .wim-menu-section-white {
      height: 100%;
      width: 12px;
      position: relative;
      .wim-menu-progress {
        position: absolute;
        top: 0;
        right: 0;
        width: 1px;
        background: $red;
      }
    }
    .wim-menu-section-text {
      border-left: solid 1px $red;
      height: 100%;
      width: 25px;
      overflow: hidden;
      position: relative;
      .wim-menu-section-name {
        position: absolute;
        left: -49px;
        top: 36%;
        width: 100px;
        text-align: center;
        transition: left 0.5s ease;
        user-select: none;
        font-family: "Nunito Sans", sans-serif;
        font-size: 12px;
        line-height: 25px;
        font-weight: 800;
        letter-spacing: 0.8px;
        color: $red;
        transform: rotate(-90deg);
        text-transform: uppercase;
        white-space: nowrap;
      }
    }

    &:hover .wim-menu-section-name {
      transform: rotate(-90deg);
      left: -37px;
    }
    &.active {
      .wim-menu-progress {
        background: $black;
      }
      .wim-menu-section-text {
        border-color: $black;
      }
      .wim-menu-section-name {
        color: $black;
        transform: rotate(-90deg);
        left: -37px;
      }
    }
  }
}
@media (max-width: 768px) {
  .wim-menu-lateral {
    display: none;
  }
}
</style>